<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="basicData" (change)="basicDataChange()" (submit)="basicDataSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{ "BASIC_DATA_TITLE" | translate | titlecase }}</h6>
            </div>

            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">

                <div class="dropdown">
                    <button class="btn btn-link dropdown-toggle" type="button" id="dropdownLangButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-globe"></i> {{ currentLang }}
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownLangButton">
                        <a class="dropdown-item" (click)="changeLang('en')">{{ "EN" | translate | titlecase }}</a>
                        <a class="dropdown-item" (click)="changeLang('ar')">{{ "AR" | translate | titlecase }}</a>
                    </div>
                </div>

                <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                    {{ "RESET" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i class="fas fa"></i>
                    {{ "NEXT" | translate | titlecase }}</button>
                <app-loader [show]="creating"></app-loader>
            </div>



        </div>
        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3">
                    <div class="alert alert-warning alert-dismissible fade show col-md-5" role="alert"
                        id="infoAlertContainer">
                        <strong> {{ "BASIC_DATA_ALERT1" | translate | titlecase }}</strong><br>
                        {{ "BASIC_DATA_ALERT2" | translate | titlecase }}<br>
                        {{ "BASIC_DATA_ALERT3" | translate | titlecase }} <br>
                        {{ "BASIC_DATA_ALERT4" | translate | titlecase }}<br>
                        {{ "BASIC_DATA_ALERT5" | translate | titlecase }}<br>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="text-center col-md-12" id="userProfileContainer">
                        <img [src]="imageUrl" class="img-fluid " width="200" id="userImageTag">
                        <!-- <img src="assets/images/stud-image.png" class="img-fluid" width="100" id="userImageTag"> -->
                        <input type="file" class="form-control col-md-4" id="userImage" formControlName="userImage"
                            (change)="userChangeImage($event)" />
                        <div class="alert alert-danger py-1 mt-1 col-md-4"
                            *ngIf="basicData.controls.userImage.touched && basicData.controls.userImage.invalid && basicData.dirty"
                            id="userImageErrorMessage">
                            {{ "PLEASE_SELECT_IMAGE" | translate | titlecase }}
                        </div>
                    </div>

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "CANDUDATE_CODE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="Candidate CODE"
                                    formControlName="candCode" readonly>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "NATIONAL_ID" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="National ID" formControlName="natId"
                                    readonly>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="English Full Name"
                                    formControlName="fullNameEnglish">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.fullNameEnglish.touched && basicData.controls.fullNameEnglish.invalid && basicData.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FULL_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Arabic Full Name"
                                    formControlName="fullNameArabic">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.fullNameArabic.touched && basicData.controls.fullNameArabic.invalid && basicData.dirty">
                                    {{ "FULL_NAME_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "DATE_OF_BIRTH" | translate | titlecase }}</label>
                                <input type="date" class="form-control" formControlName="dateOfBirth"
                                    min="{{ minDate }}" max="{{ maxDate }}">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.dateOfBirth.touched && basicData.controls.dateOfBirth.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILED_DATE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "GENDER" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="gender"
                                    (change)="changegender()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option value="M">{{ "MALE" | translate | titlecase }}</option>
                                    <option value="F">{{ "FEMALE" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.gender.touched && basicData.controls.gender.invalid && basicData.dirty">
                                    {{"PLEASE_SELECT_A_GENDER" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ADDRES_LINE_1_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="address1En">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.address1En.touched && basicData.controls.address1En.invalid && basicData.dirty">
                                    {{ "ADDRESS_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "HOME_TELEPHONE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Home Telephone"
                                    formControlName="homePhone">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.homePhone.touched && basicData.controls.homePhone.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>

                            </div>
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ADDRES_LINE_1_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Address Line 1 Arabic"
                                    formControlName="address1Ar">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.address1Ar.touched && basicData.controls.address1Ar.invalid && basicData.dirty">
                                    {{ "ADDRESS_VALIDITION" | translate | titlecase }}
                                </div>
                            </div> -->
                        </div>

                        <!-- <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ADDRES_LINE_2_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Address Line 2 English"
                                    formControlName="address2En">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.address2En.touched && basicData.controls.address2En.invalid && basicData.dirty">
                                    {{ "ADDRESS_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ADDRES_LINE_2_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Address Line 2 Arabic"
                                    formControlName="address2Ar">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.address2Ar.touched && basicData.controls.address2Ar.invalid && basicData.dirty">
                                    {{ "ADDRESS_VALIDITION" | translate | titlecase }}
                                </div>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "COUNTRY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="country"
                                    (change)="changeCountry()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of countries" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.countryNameAr : res.countryNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.country.touched && basicData.controls.country.invalid && basicData.dirty">
                                    {{"PLEASE_SELECT_A_COUNTRY" | translate | titlecase}}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "REGION" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="region"
                                    (change)="changeRegion()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of regions" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.regionNameAr : res.regionNameEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.region.touched && basicData.controls.region.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_A_REGION" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "PROVINCE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="province"
                                    (change)="changeProvince()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of provinces" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.provinceNameAr : res.provinceNameEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.province.touched && basicData.controls.province.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_A_PROVINCE" | translate | titlecase }}

                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "CITY" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="city"
                                    (change)="changeCity()">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of city" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.cityNameAr : res.cityNameEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.city.touched && basicData.controls.city.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_A_CITY" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MARTIAL_STATUS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="maritalStatus">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of maritalStatus" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.maritalStatusNameAr : res.maritalStatusNameEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.maritalStatus.touched && basicData.controls.maritalStatus.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_A_MARITIAL_STATUS" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMAIL" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="" formControlName="userEmail" readonly>

                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "PERSONAL_MOBILE_1" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Personal Mobile 1"
                                    formControlName="personalMobile1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.personalMobile1.touched && basicData.controls.personalMobile1.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1" *ngIf="basicData.hasError('samePhone')">
                                    {{ "PLEASE_ENTER_DIFFERENT_MOBILE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "PERSONAL_MOBILE_2" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Personal Mobile 2"
                                    formControlName="personalMobile2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.personalMobile2.touched && basicData.controls.personalMobile2.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMERGENCY_MOBILE_1" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Emergency Mobile 1"
                                    formControlName="emergencyMobile1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.emergencyMobile1.touched && basicData.controls.emergencyMobile1.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                                <div class="alert alert-danger py-1 mt-1" *ngIf="basicData.hasError('samePhone')">
                                    {{ "PLEASE_ENTER_DIFFERENT_MOBILE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMERGENCY_MOBILE_2" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Emergency Mobile 2"
                                    formControlName="emergencyMobile2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.emergencyMobile2.touched && basicData.controls.emergencyMobile2.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_MOBILE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMERGENCY_CONTACT_1" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Emergency Contact 2"
                                    formControlName="emergencyContact1">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.emergencyContact1.touched && basicData.controls.emergencyContact1.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_CONTACT" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMERGENCY_CONTACT_2" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Emergency Contact 2"
                                    formControlName="emergencyContact2">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.emergencyContact2.touched && basicData.controls.emergencyContact2.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_CONTACT" | translate | titlecase }}
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "MILITIRY_STATUS" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="militaryStatus">
                                    <option value="" [selected]="true">Select</option>
                                    <option *ngFor="let res of milStatus" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.milStatusNameAr : res.milStatusNameEn
                                        }}</option>

                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.militaryStatus.touched && basicData.controls.militaryStatus.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_A_MILTART_STATUS" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ENGLISH_NOTES" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="englishNotes">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.englishNotes.touched && basicData.controls.englishNotes.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_NOTES" | translate | titlecase }}
                                </div>
                            </div>

                        </div>
                        <!-- <div class="row">

                             <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ARABIC_NOTES" | translate | titlecase }}</label>
                                <input type="text" class="form-control" placeholder="Arabic Notes"
                                    formControlName="arabicNotes">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="basicData.controls.arabicNotes.touched && basicData.controls.arabicNotes.invalid && basicData.dirty">
                                    {{ "PLEASE_SELECT_AVAILD_NOTES" | translate | titlecase }}
                                </div>
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "BACHELOR_CERT" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="Bachelor Cert"
                                    formControlName="bachelorCert" readonly>

                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "BACHELOR_CARD" | translate | titlecase }}</label>
                                <input type="text" class="form-control" value="Bachelor Card"
                                    formControlName="bachelorCard" readonly>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 d-flex flex-wrap justify-content-center justify-content-lg-end">
                        <button type="reset" class="btn btn-outline-secondary m-2 rounded-0">
                            {{ "RESET" | translate | titlecase }}</button>
                        <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!creating"><i
                                class="fas fa"></i>
                            {{ "NEXT" | translate | titlecase }}</button>
                        <app-loader [show]="creating"></app-loader>
                    </div>
                </div>

            </div>
        </div>





    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>
